import {servicesData} from '../data'
import Card from '../UI/Card'
import {Link} from 'react-router-dom'
import {AiFillCaretRight} from 'react-icons/ai'
import { useState } from 'react'
import {BiCheck} from 'react-icons/bi'
import {BsArrowDownRightSquare} from 'react-icons/bs'
import {motion} from 'framer-motion'

const Services = () => {
    const [serviceSelected, setServiceSelected] = useState(0);
    const tLength = servicesData.length;
    const transition = {type: 'spring', duration: 1};

    const ChangeColor = (black) => {
        const myquery = document.querySelector('.home__services');
        if (black)
        {
            myquery.classList.remove('black');
            myquery.classList.remove('white');
            myquery.classList.add('black');
        } else {
            myquery.classList.remove('black');
            myquery.classList.remove('white');
            myquery.classList.add('white');
        }
        // document.querySelector('nav').classList.toggle('window-scroll', window.scrollY > 0);
    }

  return (
    <section className="home__services">
        <div className="home__services-container">
            <div className="services-left">
                <p>WHAT WE DO</p>
                <h1>Our Services</h1>
                <div className="serviceslist-container">
                    <div className="serviceslist-left">
                        {
                            servicesData.map(({index, title, black, path, image}) => {
                                return (
                                    <li className="services__program" key={index}>
                                        <a className={serviceSelected===index ? 'services__highlight' : 'services__unhighlight'} onClick={() => {
                                            ChangeColor(black);
                                            setServiceSelected(index);
                                        }}>{title}<BsArrowDownRightSquare className={
                                            serviceSelected===index ? 'servicesIcon__highlight' : 'servicesIcon__unhighlight'
                                            }/></a>
                                    </li>
                                )
                            })
                        }
                    </div>
                    <div className="serviceslist-right">
                        <h3>Features :</h3>
                        <motion.div
                        key={serviceSelected}
                        initial={{opacity: 0, x: -50}}
                        animate={{opacity: 1, x: 0}}
                        exit={{opacity: 0, x: 50}}
                        transition={transition}
                        className='featuresList'>
                            <ul>
                            {
                                servicesData[serviceSelected].children.map(({feature}) => {
                                    return (
                                        <li className='services__features'><BiCheck className='services__tick'/>{feature}</li>
                                    )
                                })
                            }
                            </ul>
                        </motion.div>
                        <Link to={servicesData[serviceSelected].path} className='btn sm featuresList-btn'>Read More</Link>
                    </div>               
                </div>
            </div>
            <div className="services-right">
                <div className="services-image-container">
                    <motion.img
                    key={serviceSelected}
                    initial={{opacity: 0, x: 50}}
                    animate={{opacity: 1, x: 0}}
                    exit={{opacity: 0, x: -50}}
                    transition={transition}
                    className="services-image" src={servicesData[serviceSelected].image} alt="Main Header Image" />
                </div>
            </div>
        </div>   
    </section>
  )
}

export default Services